<template>
  <div class="surface-design-top-panel">
    <div class="top-side" v-if="!create">
      <button v-if="backLink" class="collection-back-button" @click="$router.push(backLink)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="none" viewBox="0 0 20 20">
          <path d="M11.969 3.637 6.137 9.47a.75.75 0 0 0 0 1.06l5.832 5.832a.75.75 0 0 0 1.06 0 .75.75 0 0 0 0-1.06L7.727 10l5.302-5.303a.75.75 0 0 0 0-1.06.75.75 0 0 0-1.06 0z" color="#000" style="-inkscape-stroke:none"/>
        </svg>
        <span>{{ backText }}</span>
      </button>
      <div class="download-block add-mobile">
        <div class="download-block__button" @click="isShowMenu = !isShowMenu">
          <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 23 24">
            <path d="M10.2 18c0-.6.4-1 .9-1s.9.4.9 1-.4 1-.9 1-.9-.4-.9-1z"/>
            <path d="M11.1 19.8c-.9 0-1.7-.8-1.7-1.8s.8-1.8 1.7-1.8c.9 0 1.7.8 1.7 1.8s-.8 1.8-1.7 1.8zm0-2c-.1 0-.2.1-.2.2 0 .3.4.3.4 0 0-.1-.1-.2-.2-.2zm-.9-5.8c0-.6.4-1 .9-1s.9.4.9 1-.4 1-.9 1-.9-.4-.9-1z"/>
            <path d="M11.1 13.8c-.9 0-1.7-.8-1.7-1.8s.8-1.8 1.7-1.8c.9 0 1.7.8 1.7 1.8s-.8 1.8-1.7 1.8zm0-2.1c-.1 0-.2.1-.2.2 0 .3.4.3.4 0 0 0-.1-.2-.2-.2zM10.2 6c0-.6.4-1 .9-1s.9.4.9 1-.4 1-.9 1-.9-.4-.9-1z"/>
            <path d="M11.1 7.7c-.9 0-1.7-.7-1.7-1.7s.8-1.8 1.7-1.8c.9 0 1.7.8 1.7 1.8s-.8 1.7-1.7 1.7zm0-2c-.1 0-.2.1-.2.2 0 .3.4.3.4 0 0 0-.1-.2-.2-.2z"/>
          </svg>
        </div>
        <div
          v-if="isShowMenu"
          class="download-block__items"
          v-click-outside="() => isShowMenu = false"
        >
          <div
            :class="`download-block__items__item`"
            @click="$emit('rename')"
          >

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
              <path stroke="#0E4D56" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.66602 18.3329h3.66666L17.6845 7.98105c.358-.35798.358-.93838 0-1.29636l-2.3703-2.37031c-.358-.35798-.9384-.35798-1.2964 0L3.66602 14.6662v3.6667ZM11 7.33301l3.6667 3.66669"/>
            </svg>
            Rename
          </div>
          <div
            :class="`download-block__items__item`"
            @click="$emit('del')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
              <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.5 5.5h-11v12.8333c0 .5063.41041.9167.91667.9167h9.16663c.5063 0 .9167-.4104.9167-.9167V5.5Zm-12.83398 0H18.3327m-4.582-2.75H8.25065c-.50626 0-.91667.41041-.91667.91667V5.5h7.33332V3.66667c0-.50626-.4104-.91667-.9166-.91667Z"/>
            </svg>
            Delete
          </div>
        </div>
      </div>
    </div>
    <div class="left-side">
      <h1>
        <span>{{ title }}</span>
        <CreateBtn
          v-if="create"
          class="add-mobile"
          @create-new="$emit('create-new')"
          @create-color="$emit('create-color')"
          @create-print="$emit('create-print')"
          @create-texture="$emit('create-texture')"
          @create-placement-print="$emit('create-placement-print')"
        />
        <ButtonPrimary
          v-else
          class="small add-mobile"
          @click.native="$emit('edit')"
        >
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20">
              <path d="M6.7 17.4H3.3c-.4 0-.8-.3-.8-.8v-3.3c0-.2.1-.4.2-.5l9.4-9.4c.6-.6 1.6-.6 2.2 0l2.2 2.2c.6.6.6 1.6 0 2.2l-9.4 9.4c0 .1-.2.2-.4.2zm-2.6-1.5h2.3l9.2-9.2v-.1l-2.2-2.2h-.1l-9.2 9.2v2.3z"/>
            </svg>
          </template>
          <div class="add-desktop">Edit</div>
        </ButtonPrimary>
      </h1>
    </div>
    <div class="right-side">
      <div class="search-field">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21">
          <path d="M8.334 2.25c-3.627 0-6.584 2.957-6.584 6.584s2.957 6.582 6.584 6.582a6.547 6.547 0 0 0 4.088-1.432l4.547 4.547a.75.75 0 0 0 1.062 0 .75.75 0 0 0 0-1.062l-4.547-4.547a6.547 6.547 0 0 0 1.432-4.088c0-3.627-2.955-6.584-6.582-6.584zm0 1.5a5.071 5.071 0 0 1 5.082 5.084 5.07 5.07 0 0 1-5.082 5.082A5.071 5.071 0 0 1 3.25 8.834 5.073 5.073 0 0 1 8.334 3.75z"/>
        </svg>
        <input type="text" placeholder="Search" v-model="search" @keypress="doSearch">
      </div>
      <ButtonSort @sort-order="sortOrder" />
      <div class="sort-field" v-if="sortOptions.length > 0">
        <ButtonSecondary
          class="small"
          :unfolded="sortDropdown"
          @click.native="sortDropdown = !sortDropdown"
        >
          {{ sort }}
        </ButtonSecondary>
        <ul v-if="sortDropdown" v-click-outside="() => sortDropdown = false">
          <template v-for="option in sortOptions">
            <li
              :key="option.value"
              v-if="option.value !== ''"
              :class="[sort === option.name ? 'selected' : '']"
              @click="sortOption(option)"
            >
              {{ option.name }}
            </li>
          </template>
        </ul>
      </div>
      <CreateBtn
        v-if="create"
        class="add-desktop"
        @create-new="$emit('create-new')"
        @create-color="createCollection('color')"
        @create-print="createCollection('print')"
        @create-texture="createCollection('texture')"
        @create-placement-print="createCollection('print-placement')"
      />
      <div v-if="!create" style="display: flex; gap:16px; align-items: center;">
        <ButtonPrimary
          class="small add-desktop"
          @click.native="$emit('edit')"
        >
          <template v-slot:icon>
            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 20 20">
              <path d="M6.7 17.4H3.3c-.4 0-.8-.3-.8-.8v-3.3c0-.2.1-.4.2-.5l9.4-9.4c.6-.6 1.6-.6 2.2 0l2.2 2.2c.6.6.6 1.6 0 2.2l-9.4 9.4c0 .1-.2.2-.4.2zm-2.6-1.5h2.3l9.2-9.2v-.1l-2.2-2.2h-.1l-9.2 9.2v2.3z"/>
            </svg>
          </template>
          <div class="add-desktop">Edit</div>
        </ButtonPrimary>
        <div class="download-block add-desktop">
          <div class="download-block__button" @click="isShowMenu = !isShowMenu">
            <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 23 24">
              <path d="M10.2 18c0-.6.4-1 .9-1s.9.4.9 1-.4 1-.9 1-.9-.4-.9-1z"/>
              <path d="M11.1 19.8c-.9 0-1.7-.8-1.7-1.8s.8-1.8 1.7-1.8c.9 0 1.7.8 1.7 1.8s-.8 1.8-1.7 1.8zm0-2c-.1 0-.2.1-.2.2 0 .3.4.3.4 0 0-.1-.1-.2-.2-.2zm-.9-5.8c0-.6.4-1 .9-1s.9.4.9 1-.4 1-.9 1-.9-.4-.9-1z"/>
              <path d="M11.1 13.8c-.9 0-1.7-.8-1.7-1.8s.8-1.8 1.7-1.8c.9 0 1.7.8 1.7 1.8s-.8 1.8-1.7 1.8zm0-2.1c-.1 0-.2.1-.2.2 0 .3.4.3.4 0 0 0-.1-.2-.2-.2zM10.2 6c0-.6.4-1 .9-1s.9.4.9 1-.4 1-.9 1-.9-.4-.9-1z"/>
              <path d="M11.1 7.7c-.9 0-1.7-.7-1.7-1.7s.8-1.8 1.7-1.8c.9 0 1.7.8 1.7 1.8s-.8 1.7-1.7 1.7zm0-2c-.1 0-.2.1-.2.2 0 .3.4.3.4 0 0 0-.1-.2-.2-.2z"/>
            </svg>
          </div>
          <div
            v-if="isShowMenu"
            class="download-block__items"
            v-click-outside="() => isShowMenu = false"
          >
            <div
              :class="`download-block__items__item`"
              @click="$emit('rename')"
            >

              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
                <path stroke="#0E4D56" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.66602 18.3329h3.66666L17.6845 7.98105c.358-.35798.358-.93838 0-1.29636l-2.3703-2.37031c-.358-.35798-.9384-.35798-1.2964 0L3.66602 14.6662v3.6667ZM11 7.33301l3.6667 3.66669"/>
              </svg>
              Rename
            </div>
            <div
              :class="`download-block__items__item`"
              @click="$emit('del')"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
                <path stroke="#09373D" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16.5 5.5h-11v12.8333c0 .5063.41041.9167.91667.9167h9.16663c.5063 0 .9167-.4104.9167-.9167V5.5Zm-12.83398 0H18.3327m-4.582-2.75H8.25065c-.50626 0-.91667.41041-.91667.91667V5.5h7.33332V3.66667c0-.50626-.4104-.91667-.9166-.91667Z"/>
              </svg>
              Delete
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="extra-row" v-if="needExtra">
      <slot name="extra-row">
        <ButtonsGroup class="standart">
          <button :class="['btn-group', $route.name === 'surfaceDesignColors' ? 'active' : '']" @click="$router.push({ name: 'surfaceDesignColors' })">Color</button>
          <button :class="['btn-group', $route.name === 'surfaceDesignTextures' ? 'active' : '']" @click="$router.push({ name: 'surfaceDesignTextures' })">Texture</button>
          <button :class="['btn-group', $route.name === 'surfaceDesignPrints' ? 'active' : '']" @click="$router.push({ name: 'surfaceDesignPrints' })">Repeat print</button>
          <button :class="['btn-group', $route.name === 'surfaceDesignPrintPlacements' ? 'active' : '']" @click="$router.push({ name: 'surfaceDesignPrintPlacements' })">Placement print</button>
        </ButtonsGroup>
      </slot>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSurfaceDesignColorsStore } from '@/store/pinia/surfaceDesignColors'
import { useSurfaceDesignPrintsStore } from '@/store/pinia/surfaceDesignPrints'
import { useSurfaceDesignPrintPlacementsStore } from '@/store/pinia/surfaceDesignPrintPlacements'
import { useSurfaceDesignTexturesStore } from '@/store/pinia/surfaceDesignTextures'

import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import ButtonSort from '@/components/Atoms/ButtonSort.vue'
import ButtonsGroup from '@/components/Atoms/ButtonsGroup.vue'
import CreateBtn from '@/components/SurfaceDesign/CreateBtn.vue'

export default {
  name: 'TopPanelSurfaceDesign',
  components: {
    ButtonPrimary,
    ButtonSecondary,
    ButtonSort,
    ButtonsGroup,
    CreateBtn,
  },
  props: {
    create: {
      type: Boolean,
      default: true,
    },
    sortOptions: {
      type: Array,
      default: () => [],
    },
    searchQuery: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Surface Design',
    },
    needExtra: {
      type: Boolean,
      default: true,
    },
    backLink: {
      type: [String, Boolean],
      default: false,
    },
    backText: {
      type: [String, Boolean],
      default: false,
    },
  },
  data: () => ({
    search: '',
    sort: 'Sort by',
    sortDropdown: false,
    isShowMenu: false,
  }),
  computed: {
    ...mapStores(useSurfaceDesignTexturesStore),
    ...mapStores(useSurfaceDesignPrintPlacementsStore),
    ...mapStores(useSurfaceDesignPrintsStore),
    ...mapStores(useSurfaceDesignColorsStore),
  },
  methods: {
    createCollection (item) {
      switch (item) {
        case "color":
          this.$router.push('/user/surface-design-colors')
          this.surfaceDesignColorsStore.initCreateModalToggle()
          break
        case "texture":
          this.$router.push('/user/surface-design-textures')
          this.surfaceDesignTexturesStore.createModalToggle()
          break
        case "print-placement":
          this.$router.push('/user/surface-design-print-placements')
          this.surfaceDesignPrintPlacementsStore.createModalToggle()
          break
        case "print":
          this.$router.push('/user/surface-design-prints')
          this.surfaceDesignPrintsStore.createModalToggle()
          break
      }
    },
    doSearch (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        this.$emit('search', this.search)
      }
    },
    sortOrder (order) {
      this.$emit('sort-order', order)
    },
    sortOption (option) {
      this.sort = option.name
      this.sortDropdown = false
      this.$emit('sort-option', option.value)
    },
  },
  mounted () {
    if (this.searchQuery.length > 0) this.search = this.searchQuery
  },
}
</script>

<style lang="scss">
.surface-design-top-panel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 40px;
  flex-wrap: wrap;

  .top-side {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 16px;
  }

  .collection-back-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    border: none;
    background: transparent;
    cursor: pointer;
    svg {
      width: 20px;
      height: 20px;
      fill: var(--Primary-Shades-Primary);
      margin-right: 4px;
    }
    span {
      color: var(--Primary-Shades-Primary);
      font-family: "DM Sans";
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
    }
  }

  h1 {
    color: var(--text_color);
    font-family: Unbounded;
    font-size: 25px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0;
    margin-bottom: 16px;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .add-mobile {
    display: none !important;
  }
  .create-btn {
    border-right: 1px solid var(--Background);
    border-radius: 8px 0 0 8px !important;
  }
  .drop-btn {
    border-radius: 0 8px 8px 0 !important;
  }
  .btn-group {
    width: auto;
    height: 40px;
    padding: 0 25px;
    box-sizing: border-box;
    border: 1px solid var(--Dividers);
    background: var(--Background);
    color: var(--Text-Text_Secondary);

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &.active {
      border-color: var(--Active-State-Strokes);
      color: var(--Active-State-Strokes);
    }
  }

  .right-side {
    display: flex;
    flex-direction: row;
    position: relative;

    & * {
      border-radius: 8px;
    }

    .search-field {
      margin-right: 8px;
      max-width: 185px;
      position: relative;
      svg {
        width: 20px;
        height: 20px;
        fill: var(--primary);
        position: absolute;
        top: 10px;
        left: 12px;
      }
      input {
        width: 100%;
        height: 100%;
        border: 1px solid var(--Dividers);
        background: var(--Background);
        box-sizing: border-box;
        padding-left: 40px;
        padding-right: 12px;
        font-size: 14px;
      }

      .pre-search {
        position: absolute;
        z-index: 10;
        width: 100%;
        height: auto;
        left: 0;
        top: 60px;

        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 0 16px;

        border-radius: 8px;
        border: 1px solid var(--Dividers);
        background: var(--Basic-White);
        box-shadow: 0px 6px 8px 0px rgba(146, 158, 159, 0.10);

        font-family: "DM Sans";
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;

        h3 {
          color: var(--Text-Text_Secondary);
          padding: 8px 0;
          font-size: 14px;
          line-height: normal;
        }

        ul {
          margin: 0;
          padding: 0;

          cursor: pointer;

          li {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            column-gap: 16px;

            list-style: none;
            margin: 0;
            padding: 8px 0;

            color: var(--Text-Text_Primary, #1D1F29);

            font-family: "DM Sans";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;

            svg {
              width: 22px;
              height: 22px;
              position: static;
              flex-shrink: 0;
            }

            span {
              flex-grow: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .see-all {
          color: var(--Primary-Shades-Primary, #09373D);
          padding: 16px 0;
        }
      }
    }

    .button-sort {
      margin-right: 8px;
    }

    .sort-field {
      margin-right: 16px;
      position: relative;

      button {
        font-weight: 400;
      }
      ul {
        position: absolute;
        left: 0;
        top: 48px;
        z-index: 1;
        min-width: 200px;
        max-height: 160px;
        margin: 0;
        padding: 0;

        border-radius: 8px;
        border: 1px solid var(--Dividers);
        background: var(--Basic-White);
        box-shadow: 0px 6px 8px 0px rgba(146, 158, 159, 0.10);

        li {
          list-style: none;
          color: var(--Text-Text_Primary);
          font-family: "DM Sans";
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          padding: 8px 16px;
          cursor: pointer;
          transition: all ease-in-out 300ms;
          border-radius: 0;

          &:hover, &.selected {
            background: var(--Surface-Hover);
            color: var(--Button-States-Hover);
          }
        }
      }
    }
  }
  .extra-row {
    margin-top: 20px;
    width: 100%;
  }
}
@media (max-width: 760px) {
  .surface-design-top-panel {
    .right-side {
      width: 100%;
      .search-field {
        width: 100%;
        max-width: 100%;
      }
      .sort-field {
        margin-right: 0;
      }
    }
    .left-side {
      width: 100%;
    }
    .create-btn {
      padding: 0 10px !important;
    }
    .add-desktop { display: none !important; }
    .add-mobile { display: flex !important; }
  }
  .user-top-panel {
    flex-direction: column;
    align-items: stretch;

    .left-side {
      margin-bottom: 16px;

      .btn-group {
        width: 50%;
      }
    }

    .search-field {
      max-width: none !important;
      flex-grow: 1;
    }

    .sort-field {
      margin-right: 0 !important;

      ul {
        left: auto !important;
        right: 0;
      }
    }
  }
}
@media (max-width: 570px) {
  .surface-design-top-panel {
    h1 {
      font-size: 24px;
    }
    .top-side {
      margin-bottom: 36px;
    }
    .buttons-group {
      flex-wrap: wrap;
      row-gap: 16px;
      column-gap: 8px;
    }
    .btn-group {
      border-radius: 8px;
      width: calc(50% - 4px);
    }
  }
}
</style>
